import { CommonModule } from '@angular/common';
import { Component, computed, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { RecipientOtpApiService } from '../../../services/auth/recipient-otp-api.service';

@Component({
    selector: 'app-header',
    imports: [CommonModule, RouterModule, MatToolbarModule, MatButtonModule, MatIconModule, MatDividerModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    readonly title = input('');
    private readonly router = inject(Router);
    private readonly authApiService = inject(RecipientOtpApiService);
    private readonly destroyRef = inject(DestroyRef);
    private readonly isLoggingOut = signal(false);
    readonly isLoggingOutComputed = computed(() => this.isLoggingOut());

    logout(): void {
        if (this.isLoggingOut()) {
            return;
        }

        this.isLoggingOut.set(true);

        this.authApiService
            .logout()
            .pipe(
                finalize(() => this.isLoggingOut.set(false)),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe({
                complete: () => {
                    this.router.navigate(['/login']);
                },
                error: () => {
                    this.router.navigate(['/login']);
                }
            });
    }
}
